import type { OrgUnit } from "../types/org";

export function formatUnitHeadcount(unit: Pick<OrgUnit, "headcount" | "technicalHeadcount">): string {
  const base = unit.headcount ?? 0;
  const technical = unit.technicalHeadcount ?? 0;
  return technical > 0 ? `*${base}+${technical}` : `*${base}`;
}
